"use strict";

/**
 * @file
 * Search.
 */

(function ($, Drupal) {
  Drupal.behaviors.Search = {
    attach: function attach() {
      /* If there are no results, then show messages "No Results found" */
      if (!$('.search-result-outer').find('div.views-row').length) {
        $('.search-result-outer').html('<div class="views-row"><div class="items">No Results Found</div></div>');
      }
      /* Change the URL's for all the anchors in the resources type list */
      $('.js-search-resource-type').each(function () {
        var linkText = $(this).children('a').text();
        linkText = linkText.replace(/\s/g, '%20');
        var href = window.location.href;
        href = href.split('?');
        var queryParameter = href[1];
        var newURL = "".concat(/search-results/ + linkText, "/?").concat(queryParameter);
        $(this).children('a').attr('href', newURL);
      });
      /* Categary click in blog page and some other pages in tablet and mobile */
      $('.js-search-result-filter h4').click(function () {
        var windowsize = $(window).width();
        if (windowsize < 769) {
          if ($(this).parent('div').children('ul').css('display') === 'none') {
            $(this).parent('div').children('ul').slideDown();
            $(this).addClass('active');
          } else {
            $(this).parent('div').children('ul').slideUp();
            $(this).removeClass('active');
          }
        }
      });
    }
  };
})(jQuery, Drupal);